import type { InputHTMLAttributes, ReactNode } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './input.module.scss';

const styles = pickCss(css, css.root);

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
};

export const Input = ({
  className,
  disabled,
  leadingIcon,
  trailingIcon,
  ...restProps
}: InputProps) => (
  <div className={styles({ isDisabled: !!disabled }, className)}>
    {leadingIcon && <span className={css.icon}>{leadingIcon}</span>}
    <input className={css.field} disabled={disabled} {...restProps} />
    {trailingIcon && <span className={css.icon}>{trailingIcon}</span>}
  </div>
);
